const scrollBtn = document.querySelector('.scroll-to-top');
const triggerEl = document.querySelector('#hero');

if (scrollBtn && triggerEl) {
  const toggleScrollButton = () => {
    const triggerPosition = triggerEl.getBoundingClientRect().bottom;

    scrollBtn.classList.toggle('show', triggerPosition <= 0);
  };

  window.addEventListener('scroll', toggleScrollButton, {
    passive: true,
  });

  toggleScrollButton();

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}